import moment from 'moment';
import { container } from 'tsyringe';
import FORMATS from 'config/formats.js';
import { LanguageService } from 'services/LanguageService';
import VueI18n from 'vue-i18n';
var DateUtility = /** @class */ (function () {
    function DateUtility(date, format) {
        this.date = this.dateToMoment(date, format);
    }
    Object.defineProperty(DateUtility.prototype, "moment", {
        /**
         * Gets the date as a moment
         *
         * @readonly
         * @type {moment.Moment}
         * @memberOf DateUtility
         */
        get: function () {
            return this.date;
        },
        enumerable: false,
        configurable: true
    });
    DateUtility.prototype.dateToMoment = function (date, format) {
        date = date || moment(new Date());
        return (format) ? moment(date, format) : moment(date);
    };
    /**
     * Returns the formatted date
     *
     * If no format is provide the default system formatting is used:
     * < 1 day - hh:mm
     * same year - DD.MM
     * different year - DD.MM.YYYY
     *
     * @param {string} format
     * @returns {string}
     *
     * @memberOf DateUtility
     */
    DateUtility.prototype.format = function (format) {
        if (format) {
            return this.date.format(format);
        }
        var secondsSinceStart = this.date.diff(moment().startOf('day'), 'second');
        if ((secondsSinceStart > 0) && (secondsSinceStart < DateUtility.secondsInADay)) {
            return this.date.format(FORMATS.UTILITY.SAME_DAY);
        }
        return (this.date.isSame(new Date(), 'year'))
            ? this.date.format(FORMATS.UTILITY.SAME_YEAR)
            : this.date.format(FORMATS.UTILITY.DIFFERENT_YEAR);
    };
    DateUtility.prototype.languageFormat = function (language) {
        if (!language) {
            language = (container.resolve(LanguageService)).currentLanguage;
        }
        switch (language) {
            case 'fi-FI':
                return this.date.format(FORMATS.DATETIME.UI);
            default:
                return this.date.format('h:mm a - MMMM Do, YYYY');
        }
    };
    DateUtility.prototype.dayDifference = function (to, floatNumberResult) {
        if (floatNumberResult === void 0) { floatNumberResult = false; }
        to = to || moment();
        return moment(this.date).diff(this.dateToMoment(to), 'days', floatNumberResult);
    };
    DateUtility.prototype.timeSinceFormat = function (locale) {
        return moment(this.date).fromNow(locale !== 'fi-FI');
    };
    DateUtility.prototype.relativeDateTimeString = function () {
        var i18n = container.resolve(VueI18n);
        if (this.isSameDay(moment())) {
            return i18n.t('common.relative_day.today');
        }
        else if (this.isSameDay(moment().subtract(1, 'days'))) {
            return i18n.t('common.relative_day.yesterday');
        }
        return this.format();
    };
    DateUtility.prototype.isSameDay = function (day) {
        return this.date.isAfter(day.startOf('day')) && this.date.isBefore(day.endOf('day'));
    };
    DateUtility.prototype.isBefore = function (from) {
        return this.date.isBefore(from);
    };
    DateUtility.secondsInADay = 86400;
    return DateUtility;
}());
export { DateUtility };
